/* import __COLOCATED_TEMPLATE__ from './empty-ticket-type-mapping.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();